export default "__VITE_ASSET__zRQMfPWA__"